export const initialValue = [
    {
        type: 'blocks',
        children: [{text: ''}]
    }
];

export const NUMBER_TYPE = [
    {
        type: 'ordinal',
        name: '数值',
        value: 'number:ordinal',
        attr: 'type'
    },
    {
        type: 'telephone',
        name: '电话',
        value: 'telephone',
        attr: 'type'
    },
    {
        type: 'digits',
        name: '序列',
        value: 'number:digits',
        attr: 'type'
    }
];

export const BLOCK_TYPE = {
    SILENCE: 'silence', // 停顿
    SAYAS: 'sayas',
    PPT: 'pptPosition'// 读音标记
};

export const SAYAS_TYPE = {
    EN: 'en',
    NUM: 'num',
    PY: 'py'
};

export const EN_TYPE = [
    {
        type: 'letter',
        name: '字母',
        value: 'as-character',
        attr: 'interpret-as'
    },
    {
        type: 'word',
        name: '单词',
        value: 'as-word',
        attr: 'interpret-as'
    }
];

export const PY_TYPE = {
    type: 'py',
    attr: 'py'
};


